import "./SOFAScore.scss"

import { Header } from "../Header/Header";
import SideBar from "../SideBar/Sidebar";
import React, { useState, useEffect, useTransition } from 'react';
import mmhgReversible from "../../common/icons/svg/mmHg-reversible.svg";
import redRating from "../../common/icons/svg/red-rating.svg";
import yellowRating from "../../common/icons/svg/yellow-rating.svg";
import greenRating from "../../common/icons/svg/green-rating.svg";
import { connect } from "react-redux";


function SOFAScore(props) {
    const [plateletsScore, setPlateletsScore] = useState(0);
    const [GCSScore, setGCSScore] = useState(0);
    const [bilirubinScore, setBilirubinScore] = useState(0);
    const [arterialPressureScore, setArterialPressureScore] = useState(0);
    const [creatinineScore, setCreatinineScore] = useState(0);
    const [pao2Score, setPao2Score] = useState(0);
    const [fio2Score, setFio2Score] = useState(0);
    const [pfScore, setPfScore] = useState(0);
    const [mechanicalVent, setMechanicalVent] = useState("");
    const [totalSOFAScore, setTotalSOFAScore] = useState(0);


    const handlePlateletRadio = (score) => {
        setPlateletsScore(score);
    }
    const handleGCSScore = (score) => {
        setGCSScore(score);
    }
    const handleBilirubinScore = (score) => {
        setBilirubinScore(score);
    }
    const handleArterialPressure = (score) => {
        setArterialPressureScore(score);
    }
    const handlePao2Score = (score) => {
        setPao2Score(score);
    }
    const handleFio2Score = (score) => {
        setFio2Score(score);
    }
    const handleCreatinineScore = (score) => {
        setCreatinineScore(score);
    }
    const handleMechanicalVentRadio = (event) => {
        // console.log("event mech", event.target.id);
        setMechanicalVent(event.target.id);

    }
    const handlepfRatio = (pfScore) => {
        if (pfScore >= 400) setPfScore(0);
        else if (pfScore < 400 && pfScore >= 300) setPfScore(1);
        else if (pfScore < 300 && pfScore >= 200) setPfScore(2);
        else if (pfScore < 200 && pfScore >= 100 && mechanicalVent === "yes") setPfScore(3);
        else if (pfScore < 100 && mechanicalVent === "yes") setPfScore(4);
        else if (pfScore < 200 && mechanicalVent === "no") setPfScore(2);
    }
    useEffect(() => {
        if (fio2Score !== 0) {
            let calculatedPfRatio = (pao2Score * 100) / fio2Score;
            handlepfRatio(calculatedPfRatio);
        } else setPfScore(0);
    }, [fio2Score, pao2Score, mechanicalVent])

    useEffect(() => {
        setTotalSOFAScore(plateletsScore + GCSScore + bilirubinScore + arterialPressureScore + pfScore + creatinineScore);
    }, [plateletsScore, GCSScore, bilirubinScore, arterialPressureScore, pfScore, creatinineScore]);

    return (
        <div className="sofa-score-container">
            <Header
                selectedWard={props.selectedWard}
            />
            <SideBar />
            <div className="sofa-score-body">
                <div className="score-top-header">
                    <div className="sofa-heading-container">
                        <span className="heading">SOFA</span>
                        <div className={`show-score
                                        ${totalSOFAScore > 11 ? "red-score" : ""} 
                                        ${(totalSOFAScore <= 11) && (totalSOFAScore >= 8) ? "yellow-score" : ""}
                                        ${totalSOFAScore < 8 ? "green-score" : ""}
                                         `}>Score: {totalSOFAScore}</div>
                    </div>
                    <div className="sofa-range-container">
                        <div className="common-rating-cls">
                            <img className="rating-color" src={redRating} />
                            <span>Danger: 12 - 24</span>
                        </div>
                        <div className="common-rating-cls">
                            <img className="rating-color" src={yellowRating} />
                            <span>Moderate: 8 - 11</span>
                        </div>
                        <div className="common-rating-cls">
                            <img className="rating-color" src={greenRating} />
                            <span>Safe: 0 - 7</span>
                        </div>
                    </div>
                    <div className="sofa-rating-container">
                        <div className="common-rating-cls">
                            <div className="pao2-container">
                                <div className="pao2  common-param">PaO2</div>
                                <input
                                    type="text"
                                    className="pao2-value"
                                    onChange={(event) => handlePao2Score(event.target.value)}
                                    onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0')}
                                />
                            </div>
                            <div className="common-side-container">
                                <span className="mmHg">mmHg</span>
                                <img src={mmhgReversible} />
                            </div>
                        </div>
                        <div className="common-rating-cls">
                            <div className="fio2-container">
                                <div className="fio2  common-param">FiO2</div>
                                <input
                                    type="text"
                                    className="fio2-value"
                                    onChange={(event) => handleFio2Score(event.target.value)}
                                    onInput={(e) => e.target.value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0')}
                                />
                            </div>
                            <div className="common-side-container">
                                <span className="">%</span>
                            </div>
                        </div>
                        <div className="vent-container">
                            <span>Patient Mechanically Ventilated</span>
                            <div className="vent-input-container">
                                <div className="vent-common">
                                    <input type="radio" id="yes" name="vent-yes-no" onChange={(event) => handleMechanicalVentRadio(event)} />
                                    <label htmlFor="yes"> Yes</label>
                                </div>
                                <div className="vent-common">
                                    <input type="radio" id="no" name="vent-yes-no" onChange={(event) => handleMechanicalVentRadio(event)} />
                                    <label htmlFor="no"> No</label>
                                </div>
                            </div>
                        </div>
                        <div className="mcq-score">{pfScore}</div>
                    </div>
                </div>
                <div className="sofa-mcq-container">
                    <div className="common-mcq">
                        <div className="mcq-heading">Platelets, x10³/µL</div>
                        <div className="mcq-score">{plateletsScore}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="1.1" name="platelets" onClick={() => handlePlateletRadio(0)} />
                                <label htmlFor="1.1">≥150 (0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="1.2" name="platelets" onClick={() => handlePlateletRadio(1)} />
                                <label htmlFor="1.2">100 - 149 (+1)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="1.3" name="platelets" onClick={() => handlePlateletRadio(2)} />
                                <label htmlFor="1.3">50 - 99 (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="1.4" name="platelets" onClick={() => handlePlateletRadio(3)} />
                                <label htmlFor="1.4">20 - 49 (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="1.5" name="platelets" onClick={() => handlePlateletRadio(4)} />
                                <label htmlFor="1.5">&#60; 20 (+4)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Glasgow Coma Scale</div>
                        <div className="mcq-score">{GCSScore}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="2.1" name="gcs-score" onClick={() => handleGCSScore(0)} />
                                <label htmlFor="2.1">15 (0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="2.2" name="gcs-score" onClick={() => handleGCSScore(1)} />
                                <label htmlFor="2.2">13 - 14 (+1)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="2.3" name="gcs-score" onClick={() => handleGCSScore(2)} />
                                <label htmlFor="2.3">10 - 12 (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="2.4" name="gcs-score" onClick={() => handleGCSScore(3)} />
                                <label htmlFor="2.4">6 - 9 (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="2.5" name="gcs-score" onClick={() => handleGCSScore(4)} />
                                <label htmlFor="2.5" >&#60; 6 (+4)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Bilirubin, mg/dL (μmol/L)</div>
                        <div className="mcq-score">{bilirubinScore}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="3.1" name="billirubin" onClick={() => handleBilirubinScore(0)} />
                                <label htmlFor="3.1">&#60; 1.2 (&#60; 20) (0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="3.2" name="billirubin" onClick={() => handleBilirubinScore(1)} />
                                <label htmlFor="3.2">1.2-1.9 (20-32) (+1)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="3.3" name="billirubin" onClick={() => handleBilirubinScore(2)} />
                                <label htmlFor="3.3">2.0-5.9 (33-101) (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="3.4" name="billirubin" onClick={() => handleBilirubinScore(3)} />
                                <label htmlFor="3.4">6.0-11.9 (102-204) (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="3.5" name="billirubin" onClick={() => handleBilirubinScore(4)} />
                                <label htmlFor="3.5">≥12.0 (&#62; 204) (+4)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Mean arterial pressure OR administration of vasoactive agents required</div>
                        <div className="mcq-score">{arterialPressureScore}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="4.1" name="arterial-pressure" onClick={() => handleArterialPressure(0)} />
                                <label htmlFor="4.1">No hypotension (+0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="4.2" name="arterial-pressure" onClick={() => handleArterialPressure(1)} />
                                <label htmlFor="4.2">MAP &#60; 70 mmHg (+1)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="4.3" name="arterial-pressure" onClick={() => handleArterialPressure(2)} />
                                <label htmlFor="4.3">DOPamine ≤ 5 or DOBUTamine (any dose) (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="4.4" name="arterial-pressure" onClick={() => handleArterialPressure(3)} />
                                <label htmlFor="4.4">DOPamine &gt; 5 or EPINEPHrine &lt; 0.1 or norEPINEPHrine &lt;0.1 (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="4.5" name="arterial-pressure" onClick={() => handleArterialPressure(4)} />
                                <label htmlFor="4.5">DOPamine &#62; 15, EPINEPHrine &#62; 0.1, or norEPINEPHrine  &#62; 0.1 (+4)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Creatinine, mg/DL (μmol/L) or urine output</div>
                        <div className="mcq-score">{creatinineScore}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="5.1" name="creatinine-mcq" onClick={() => handleCreatinineScore(0)} />
                                <label htmlFor="5.1">&lt;1.2 (&lt;110) (+0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="5.2" name="creatinine-mcq" onClick={() => handleCreatinineScore(1)} />
                                <label htmlFor="5.2">1.2 - 1.9 (110-170) (+1)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="5.3" name="creatinine-mcq" onClick={() => handleCreatinineScore(2)} />
                                <label htmlFor="5.3">2.0 - 3.4 (171 - 299) (+2)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="5.4" name="creatinine-mcq" onClick={() => handleCreatinineScore(3)} />
                                <label htmlFor="5.4">3.5 - 4.9 (300 - 440) or UOP &lt; 500 ml/day (+3)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="5.5" name="creatinine-mcq" onClick={() => handleCreatinineScore(4)} />
                                <label htmlFor="5.5">&ge; 5 (&gt;440) or UOP &lt; 200 ml/day (+4)</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sofa-total-rating-container">
                    <span>Total SOFA Score</span>
                    <div className="total-rating">{totalSOFAScore}</div>
                </div>
                <div className="submit-btn-container">
                    <div className="submit-btn" onClick={() => props.handleSubmitClick(totalSOFAScore)}>Submit</div>
                </div>
            </div>
        </div>
    )
}


const mapStateToProps = (state, ownProps) => {

    return {
        selectedWard: state.wardDetailsReducer && state.wardDetailsReducer.wardData && state.wardDetailsReducer.wardData.selectedWard,
    };
};

export default connect(mapStateToProps, null)(SOFAScore);
